






import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WDialogView extends BaseComponent {
	get dialogs() {
		return app.store.dialogs;
	}

	get show() {
		return this.dialogs.length;
	}
}
